import {Navigate, Outlet} from "react-router-dom";

const useAuth = () => {
    // Admins have the update portal token; stations and support only the access token
    return localStorage.getItem("_MIHEALTHTOKEN") || localStorage.getItem("_MIHEALTHACCESSTOKEN");
};

const ProtectedRoutes = () => {
    const isAuth = useAuth();
    return isAuth ? <Outlet/> : <Navigate to="/"/>;
};

export default ProtectedRoutes;
